<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import MenuCard from './menuCard/index.vue';

export default {
  name: 'Menu',
  components: { MenuCard },
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      activeMenuItem: '',
    };
  },
  computed: {
    ...mapGetters(['get_user', 'get_navigation', 'get_user_permissions']),
    navigationLinks() {
      let linksArray = [];
      //First menu filter
      let isFirstMenu = false;
  /*    let firstMenu = [];
      this.get_navigation.links[0].panels[0].links.forEach((menuItem) => {
        if(this.checkPermission(menuItem.permission)){
          isFirstMenu = true;
          firstMenu.push(menuItem)
        }
      })
      if(isFirstMenu){
        let menuObject = JSON.parse(JSON.stringify(this.get_navigation.links[0]));
        menuObject.panels[0].links = firstMenu;
        linksArray.push(menuObject)
      }*/

      // Second menu filter
      let navLinks = JSON.parse(JSON.stringify(this.get_navigation.links[1]));
      let isSecondMenu = false;
      let shipmentSettings = [];  // 3
      let systemSettings = [];    // 3
      let settings = [];          // 2
      let shipments = [];         // 2
      let finance = [];           // 2
      let secondPanels = [];      // 1

      //shipping settings submenu object is navLinks.panels[4]
      navLinks.panels[5].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          shipmentSettings.push(menuItem)
        }
      })
      //system settings submenu object is navLinks.panels[3]
      navLinks.panels[4].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          systemSettings.push(menuItem)
        }
      })
      //shipment submenu object is navLinks.panels[1]
      navLinks.panels[1].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          shipments.push(menuItem)
        }
      })
      //finance submenu
      navLinks.panels[3].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          finance.push(menuItem)
        }
      })


      let menuObject = JSON.parse(JSON.stringify(this.get_navigation.links[1]));

      //*** SECOND LEVEL LINKS ***//
      if(isSecondMenu){
        let settingsLinks = [];
        if(shipmentSettings.length > 0) {
          menuObject.panels[2].links[1].permission = true;
          settingsLinks.push(menuObject.panels[2].links[1])
          menuObject.panels[5].links = shipmentSettings;
        } else {
          menuObject.panels[2].links[1].permission = false;
        }
        if(systemSettings.length > 0) {
          menuObject.panels[2].links[0].permission = true;
          settingsLinks.push(menuObject.panels[2].links[0])
          menuObject.panels[4].links = systemSettings;
        } else {
          menuObject.panels[2].links[0].permission = false;
        }
        if(finance.length > 0) {
          menuObject.panels[3].links[0].permission = true;
          finance.push(menuObject.panels[3].links[0])
        } else {
          menuObject.panels[3].links[0].permission = false;
        }
        menuObject.panels[2].links = settingsLinks;
        if(shipments.length > 0){
          menuObject.panels[1].links = shipments;
        }
      }

      //*** MAIN LEVEL LINKS ***//
      //In old version main level links was filled inside IF statement from above

      let mainLevelLinks = [];
      //Dashboard
      if(this.checkPermission(navLinks.panels[0].links[0].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[0])
      }
      //If shipments have some submenu options than show main menu option
      if(shipments.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[1])
      }
      if(finance.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[5])
      }
      //Contacts
      if(this.checkPermission(navLinks.panels[0].links[2].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[2])
      }
      //Reports
      if(this.checkPermission(navLinks.panels[0].links[4].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[4])
      }
      //Settings
      if(shipmentSettings.length > 0 || systemSettings.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[3])
      }

      //New main menu option needs to be added here
      //If it is multi level option, probably should be added in second level links also

      if(mainLevelLinks.length > 0){
        menuObject.panels[0].links = mainLevelLinks;
      }

      //linksArray.push(menuObject)

      // Push third
      linksArray.push(this.get_navigation.links[2]);
      return linksArray;
    },
  },
  methods: {
    checkPermission(permission) {
      let result = false;
      this.get_user_permissions.forEach((perm) => {
        if(perm.acl_route_group == permission) result = perm.view;
      })
      return result;
    },
    filterMenu(panel) {
      // First level
      panel[0].links
    },
    closeMenu() {
      this.$store.dispatch('SET_ACTIVE_MENU', '');
      this.$store.dispatch('CLOSE_NAVIGATION');
    },
    openMenu(type) {
      if (this.get_navigation.activeMenuItem === type && this.get_navigation.isOpen) {
        // CLOSE MENU
        this.$store.dispatch('SET_ACTIVE_MENU', '');
        this.$store.dispatch('CLOSE_NAVIGATION');
      } else {
        // OPEN MENU
        this.$store.dispatch('SET_ACTIVE_MENU', type);
        this.$store.dispatch('OPEN_NAVIGATION');
      }
    },
  },
};
</script>
